// Colour + label for each OrderItemStatus, shared by the dashboard's donut chart
// and its status badges.
export const STATUS_COLORS: Record<string, string> = {
  DELIVERED: '#10b981',
  INVOICED: '#06b6d4',
  PAID: '#059669',
  ENROUTE: '#3b82f6',
  APPROVED: '#8b5cf6',
  ASSIGNED: '#f59e0b',
  READY_FOR_PICKUP: '#f97316',
  PENDING: '#94a3b8',
  WAITLIST: '#d97706',
  REJECTED: '#ef4444',
  CUSTOMER_CANCELLED: '#6b7280',
  PREPAY_REQUIRED: '#ec4899',
  ON_HOLD: '#f93816',
  INVENTORY: '#0d9488',
};

export const STATUS_LABELS: Record<string, string> = {
  DELIVERED: 'Delivered',
  INVOICED: 'Invoiced',
  PAID: 'Paid',
  ENROUTE: 'En Route',
  APPROVED: 'Accepted',
  ASSIGNED: 'Assigned',
  READY_FOR_PICKUP: 'Ready',
  PENDING: 'Pending',
  WAITLIST: 'Waitlist',
  REJECTED: 'Rejected',
  CUSTOMER_CANCELLED: 'Cancelled',
  PREPAY_REQUIRED: 'Prepay',
  ON_HOLD: 'Frozen',
  INVENTORY: 'Inventory',
};
